import React, { useEffect, useRef } from 'react';
import { LinkedDataRequestProject } from '../../../../slices/marketplace/timeline/models/linked-data-request-project.model';
import { TimelineParty } from '../../../../slices/marketplace/timeline/models/enums/timeline-party.enum';
import { Button } from 'reactstrap';
import './DataRequestProjectView.scss';
import createNotification from '../../../../utils/createNotification';

interface DataRequestProjectViewProps {
    party: TimelineParty;
    project: LinkedDataRequestProject;
    onCancel: () => void;
    questionnaireId: number;
    engagementId?: number;
    isReadOnly?: boolean;
}

export const DataRequestProjectView = (props: DataRequestProjectViewProps) => {
    const iframeRef = useRef<HTMLIFrameElement>(null);
    useEffect(() => {
        const params = new URLSearchParams({
            projectId: props.project.dataRequestProjectId.toString(),
            isAdmin: (props.party === TimelineParty.VetValue).toString(),
            projectName: props.project.projectName,
            isExternalProject: 'true',
            questionnaireId: props.questionnaireId?.toString() || '',
            tab: props.questionnaireId ? '3' : '1',
            isReadOnly: (!!props.isReadOnly).toString(),
        });
        if (props.engagementId) {
            params.append('engagementId', props.engagementId.toString());
        }

        const iframe = document.getElementById(
            'data-request-frame'
        ) as HTMLIFrameElement;
        if (iframe) {
            iframe.src = `/data-request-dashboard-built-in?${params.toString()}`;
        }
    }, [props.project]);

    useEffect(() => {
        const handleMessage = (e: MessageEvent) => {
            if (e.data?.type === 'setHeight' && iframeRef.current) {
                const minHeight =
                    window.innerHeight -
                    (iframeRef.current.getBoundingClientRect().top || 0) -
                    70;
                const newHeight = Math.max(e.data.height, minHeight);
                iframeRef.current.style.height = `${newHeight}px`;
            }
            if (e.data?.type === 'notification') {
                createNotification(
                    e.data.payload.message,
                    e.data.payload.notificationType,
                    true
                );
            }
        };

        window.addEventListener('message', handleMessage);

        window.addEventListener('scroll', () => {
            const iframe = document.querySelector('iframe');
            iframe?.contentWindow?.postMessage(
                { type: 'PARENT_SCROLL', scrollY: window.scrollY },
                '*'
            );
        });
        return () => {
            window.removeEventListener('message', handleMessage);
            window.removeEventListener('scroll', () => {});
        };
    }, []);

    return (
        <div className="data-request-project-view">
            <div className="body_inner_content">
                <div className="obpbq_row valuation_section">
                    <div className="sampledetail">
                        <div className="mb-2 d-flex justify-content-between align-items-center">
                            <strong>{props.project.projectName}</strong>
                            <Button
                                color="primary"
                                onClick={() => props.onCancel()}>
                                Back
                            </Button>
                        </div>
                    </div>
                </div>
                <iframe id="data-request-frame" ref={iframeRef}></iframe>
            </div>
        </div>
    );
};
